var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 765 215",
    width: 765,
    height: 215,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_new-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-101.092,-83.04,34.08,-41.489,126.206,110.129)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cc62e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d6323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(50.568,-73.554,31.727,21.812,184.378,93.508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cc62e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d6323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.562,-33.494,65.844,48.286,201.333,135.216)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cc62e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d6323"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-179-254h1122.52v793.7h-1122.52z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: url(#g2) } \n\t\t.s2 { fill: url(#g3) } \n\t\t.s3 { fill: #1d6323 } \n\t\t.s4 { fill: #6bc52e } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    className: "s0",
    d: "m160.5 105.7c-48.2-92.3-68.1-68.1-156.2-97.4 0 0 25.9 131.7 156.2 97.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "s1",
    d: "m168.9 106.9c36-23.3 92.3-44.4 77.5-102.9-43.7 32.9-86.6 17.4-77.5 102.9z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    className: "s2",
    d: "m176 110.6c19.1 25 36 21.4 52.2 17.9 6.5-1.4 12.8-2.9 19.2-2.4-17.9-15.2-26.1-23-40-23-7.8 0-17.4 2.5-31.4 7.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: g74",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    fillRule: "evenodd",
    className: "s3",
    d: "m58.9 178.4l18.5-1.8q1.7 9.3 6.8 13.7 5.1 4.4 13.8 4.4 9.2 0 13.9-3.9 4.6-3.9 4.6-9.1 0-3.4-1.9-5.7-2-2.4-6.9-4.1c-2.2-0.8-7.3-2.1-15.2-4.1q-15.3-3.8-21.5-9.3-8.7-7.8-8.7-19 0-7.2 4.1-13.5 4.1-6.2 11.8-9.5 7.6-3.3 18.5-3.3c11.9 0 20.7 2.6 26.7 7.8q9 7.8 9.5 20.8l-19.1 0.8q-1.2-7.3-5.2-10.5-4-3.2-12.1-3.1-8.3-0.1-13 3.4-3 2.1-3 5.8 0 3.4 2.8 5.7 3.6 3.1 17.5 6.3 13.9 3.3 20.6 6.8 6.6 3.5 10.4 9.6 3.8 6.1 3.8 15 0 8.1-4.5 15.2-4.5 7.1-12.8 10.5-8.2 3.5-20.5 3.5-17.9 0-27.5-8.3-9.6-8.3-11.4-24.1zm92.6-63.6h18v94.3h-18zm50.1 46.8l-16.4-3q2.7-9.9 9.5-14.6 6.7-4.8 20-4.8 12.1 0 18 2.9 6 2.9 8.4 7.3 2.4 4.4 2.4 16.1l-0.2 21.1q0 9 0.9 13.3c0.5 2.8 1.6 5.9 3.2 9.2h-17.9q-0.7-1.8-1.7-5.4-0.4-1.6-0.6-2.1-4.7 4.5-10 6.8-5.2 2.2-11.2 2.2-10.6 0-16.6-5.7-6.1-5.7-6.1-14.5 0-5.8 2.8-10.3 2.7-4.5 7.7-6.9 5-2.4 14.4-4.3 12.6-2.3 17.5-4.4v-1.8c0-3.5-0.8-5.9-2.5-7.4q-2.6-2.2-9.7-2.3-4.9 0-7.6 2-2.7 1.8-4.3 6.6zm24.1 14.7q-3.4 1.1-11 2.7-7.5 1.7-9.8 3.2-3.5 2.5-3.5 6.3 0 3.9 2.8 6.6 2.8 2.8 7.2 2.8 4.9 0 9.3-3.2 3.3-2.5 4.3-6 0.7-2.3 0.7-8.8zm34.2-35.5h16.7v9.3q8.9-10.9 21.3-10.9 6.6 0 11.4 2.7 4.8 2.7 7.9 8.2 4.5-5.5 9.7-8.2 5.2-2.7 11.1-2.7 7.6 0 12.8 3.1c3.4 2 6 5 7.7 8.9q1.9 4.4 1.9 14.2v43.7h-18.1v-39.1q0-10.1-1.8-13.1-2.5-3.8-7.7-3.9-3.8 0-7.2 2.4-3.3 2.3-4.8 6.8-1.5 4.4-1.5 14.1v32.8h-18.1v-37.5q0-9.9-0.9-12.8-1-2.9-3-4.3-2-1.4-5.5-1.5-4.2 0-7.5 2.3-3.4 2.3-4.8 6.5-1.5 4.2-1.5 14.1v33.2h-18.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    fillRule: "evenodd",
    className: "s4",
    d: "m368.6 209.2v-94.3h35.6q9.4 0 14.3 0.9 7 1.2 11.7 4.4c3.1 2.2 5.6 5.2 7.5 9.1q2.9 5.9 2.9 12.9 0 12-7.6 20.4-7.7 8.3-27.7 8.3h-24.2v38.3zm12.5-49.4h24.4q12.1 0 17.1-4.5 5.1-4.6 5.1-12.7 0-5.9-3-10.2-3-4.2-7.9-5.5-3.1-0.8-11.6-0.8h-24.1zm69.6 15.3q0-19 10.5-28.1 8.8-7.6 21.5-7.6 14.1 0 23 9.2 9 9.2 9 25.5 0 13.2-4 20.7-3.9 7.6-11.5 11.8-7.6 4.2-16.5 4.2-14.3 0-23.2-9.2-8.8-9.2-8.8-26.5zm11.9 0q0 13.1 5.7 19.6 5.7 6.6 14.4 6.5 8.6 0 14.4-6.5 5.7-6.6 5.7-20 0-12.7-5.8-19.2-5.7-6.5-14.3-6.5-8.7 0-14.4 6.5-5.7 6.4-5.7 19.6zm65.4-60.2h11.6v94.3h-11.6zm74.1 85.9q-6.5 5.4-12.4 7.7-6 2.2-12.8 2.2-11.2 0-17.3-5.4-6-5.6-6-14.1 0-5 2.3-9.2 2.2-4.1 5.9-6.6 3.8-2.5 8.4-3.8 3.4-0.9 10.3-1.8 14-1.6 20.6-4 0.1-2.3 0.1-3 0-7.1-3.3-9.9c-3-2.7-7.4-4-13.2-4q-8.1 0-12.1 2.9-3.8 2.9-5.7 10.1l-11.3-1.5q1.5-7.3 5.1-11.7 3.5-4.5 10.2-6.9 6.7-2.4 15.5-2.5 8.7 0.1 14.2 2.1 5.5 2.1 8 5.2 2.6 3.1 3.6 7.9 0.6 2.9 0.6 10.6v15.5q0 16.1 0.8 20.4 0.7 4.3 2.9 8.2h-12.1q-1.8-3.6-2.3-8.4zm-1-25.9q-6.3 2.6-18.9 4.4-7.1 1-10.1 2.3-3 1.3-4.6 3.8-1.6 2.5-1.6 5.5 0 4.6 3.5 7.7 3.5 3.1 10.3 3.1 6.7 0 11.9-2.9 5.2-3 7.7-8.1 1.8-3.9 1.8-11.5zm29.7 34.3v-68.3h10.4v9.7q7.5-11.3 21.7-11.3 6.2 0 11.4 2.2 5.2 2.3 7.7 5.9c1.7 2.4 2.9 5.2 3.6 8.5q0.7 3.2 0.7 11.3v42h-11.6v-41.6q0-7-1.4-10.6-1.3-3.5-4.7-5.6-3.5-2.1-8.1-2.1c-5 0-9.2 1.6-12.8 4.7q-5.4 4.7-5.4 17.9v37.3zm117.6 0v-8.7q-6.5 10.2-19.1 10.2-8.2 0-15-4.5-6.9-4.5-10.6-12.6-3.8-8-3.8-18.5 0-10.2 3.4-18.6 3.4-8.3 10.2-12.7 6.9-4.5 15.3-4.5 6.2 0 11 2.6 4.8 2.6 7.8 6.8v-33.8h11.5v94.3zm-36.6-34.1q0 13.1 5.6 19.6 5.5 6.5 13 6.5 7.6 0 12.9-6.2 5.3-6.2 5.3-19 0-14-5.4-20.5-5.4-6.6-13.3-6.6-7.7 0-12.9 6.3-5.2 6.3-5.2 19.9z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo_new.130ba294aefe3ab860b4b95d037fc8dc.svg";
export { ForwardRef as ReactComponent };